/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable array-callback-return */
import {
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import TextArea from '@orientaction/commons/TextArea';
import { ShareFixedHeader } from '@orientaction/components';
import ItemCitation from '@orientaction/components/Admin/Game/ItemCitation';
import ItemEncyclopedie from '@orientaction/components/Admin/Game/ItemEncyclopedie';
import { LayoutResultat } from '@orientaction/layouts';
import { getFromLS } from '@orientaction/utils';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import type { EbookFrontUserResponse } from '@orientaction/types';
import { claimShareResourcesAfterAuth } from '../../../utils/claimAuthorizedResource';
import { apiServiceNative } from '../../../utils/fetchNative';
import style from '../style';
import MediaVideoPlayer from '@orientaction/components/MediaVideoPlayer';
import InlineSignup from '../../v2/MinorTestV2/InlineSignup';
import type { FC } from 'react';

const ViewEbook: FC = () => {
  const classes = style();
  const [url, setUrl] = useState<string>('');
  const [catalogEbookId, setCatalogEbookId] = useState<number | ''>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [showSignup, setShowSignup] = useState(false);
  const signupTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const { id, index }: any = useParams();
  const [allBloks, setAllBlocks] = useState<any>([]);
  const token = getFromLS('userToken') || '';
  const isDisconnected = !token;

  useEffect(() => {
    const fetchGameDetails = async () => {
      setLoading(true);
      try {
        const response: EbookFrontUserResponse = await apiServiceNative.get(`/api/ebook-front-user/${id}`);
        if (response) {
          setAllBlocks(response.ebook?.content || []);
          setUrl(response.ebook?.couverture || '');
          if (response.ebook?.id) {
            setCatalogEbookId(Number(response.ebook.id));
          }
          // setUrl()
        } else {
          console.error('Invalid response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching game details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGameDetails();
  }, [id]);

  useEffect(() => {
    if (isDisconnected) {
      return;
    }
    const userId = Number(JSON.parse(getFromLS('userInfos') || '{}')?.id);
    if (!userId) {
      return;
    }
    claimShareResourcesAfterAuth({ userId }).catch(() => undefined);
  }, [isDisconnected]);

  useEffect(() => {
    if (!isDisconnected) return undefined;

    signupTimerRef.current = setTimeout(() => {
      setShowSignup(true);
    }, 30000);

    return () => {
      if (signupTimerRef.current) {
        clearTimeout(signupTimerRef.current);
      }
    };
  }, [isDisconnected, id]);

  const renderTypeBlock = (block: any, ind: number) => {
    switch (block?.bloc_template) {
      case 1:
        return (
          <div
            style={
              block?.contentForType !== 'citation'
                ? {
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 31,
                    justifyContent: block?.alignement || 'flex-start',
                  }
                : {}
            }>
            {block?.contentForType === 'normal' && (
              <div
                className={classes.blockContentTextNormal}
                style={{ color: '#000A8C' }}
                dangerouslySetInnerHTML={{ __html: block?.paragraphe }}
              />
            )}
            {block?.contentForType === 'citation' && (
              <ItemCitation text={block?.citation} autor={block?.author} isEbook={true} />
            )}
            {block?.contentForType === 'encyclopedia' && (
              <ItemEncyclopedie text={block?.encyclopedia} isEbook={true} />
            )}
          </div>
        );
      case 2:
        return (
          <div
            id={`title-${ind}`}
            className={block?.title_type === 'subtitle' ? classes.subtitleUser : classes.titleUser}>
            {block?.title}
          </div>
        );

      case 3:
        return (
          <div>
            <div className={classes.qcmTitle}>{block?.qcm_title}</div>
            <div style={{ marginTop: 15 }}>
              {block?.qcm[0]?.response?.map((q: any) => (
                <>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={q.id === parseInt(block?.response_qcm_user || '0', 10)}
                        color="primary"
                        style={{ padding: 6 }}
                        onChange={() => updateQCM(q.apiType, ind, q.id)}
                        checkedIcon={<span className={clsx(classes.iconC, classes.checkedIcon)} />}
                        icon={<span className={classes.iconC} />}
                      />
                    }
                    label={
                      <div className={classes.labelQCM}>
                        {' '}
                        {q.typeReponse === 'text' ? 'Autre' : q.labelRadio}{' '}
                      </div>
                    }
                    style={{ paddingTop: 2, paddingBottom: 2, display: 'flex', marginLeft: -5 }}
                  />
                  {q.typeReponse === 'text' && (
                    <TextArea
                      name="text"
                      value={
                        q.id === parseInt(block?.response_qcm_user || '0', 10)
                          ? block.response_qcm_text_user
                          : ''
                      }
                      notBorder={true}
                      onChange={e => updateQCMText(q.apiType, ind, q.id, e.target.value)}
                      readOnly={q.id !== parseInt(block?.response_qcm_user || '0', 10)}
                      placeholder="Si autre, veuillez indiquer votre réponse"
                      editArea={true}
                    />
                  )}
                </>
              ))}
            </div>
          </div>
        );

      case 4:
        return (
          <div>
            <div className={classes.qcmTitle}>
              <pre style={{ margin: 0, fontFamily: 'Poppins', whiteSpace: 'break-spaces' }}>
                {block?.free_question_title}
              </pre>
            </div>
            <div style={{ marginTop: 15 }}>
              <TextArea
                name="text"
                value={block?.response_free_question_user || ''}
                notBorder={true}
                onChange={e => updateFreeQuestion(block?.updateUrl, e.target.value)}
                placeholder="Veuillez indiquer votre réponse"
                editArea={true}
                numberLine={block?.numLines}
              />
            </div>
          </div>
        );
      case 5:
        return (
          <img
            src={block?.img || ''}
            alt=""
            style={{
              width: '100%',
              height: 'auto',
              cursor: block?.checkedLink ? 'pointer' : 'default',
            }}
            onClick={() => {
              if (block?.checkedLink) {
                window.open(block?.imgLink, '_blank');
              }
            }}
          />
        );
      case 6:
        return (
          <div className={classes.containerSommaireUser}>
            <div className={classes.titleUser} style={{ marginTop: 0 }}>
              Sommaire
            </div>
            <div className={classes.containerChildrenSommaire}>
              {allBloks?.map((chapter: any, i: number) => {
                if (chapter?.bloc_template === 2) {
                  return (
                    <div
                      key={(chapter.id || chapter.title) ?? i}
                      className={
                        chapter.title_type === 'subtitle'
                          ? classes.subtitleSommaireUser
                          : classes.titleSommaireUser
                      }
                      style={{ cursor: 'pointer', ...(i === 0 ? { marginTop: 25 } : {}) }}
                      onClick={() => scrollToSection(i)}>
                      {chapter.title}
                    </div>
                  );
                }
              })}
            </div>
          </div>
        );
      case 7:
        return (
          <div>
            <MediaVideoPlayer videoUrl={block?.videoBook} />
          </div>
        );
      default:
    }
  };

  const updateQCM = async (apiType: any, ind: number, i: any) => {
    try {
      const response = await apiServiceNative.put(`/api${apiType}`, {});
      if (response && response.id) {
        setAllBlocks((prevBlocks: any) => {
          const newItems = [...prevBlocks];
          newItems[ind].response_qcm_user = i;
          return newItems;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  const updateQCMText = async (apiType: any, ind: number, i: any, value: any) => {
    try {
      const resp = await apiServiceNative.put(`/api${apiType}`, { response: value });
      if (resp && resp.id) {
        setAllBlocks((prevBlocks: any) => {
          const newItems = [...prevBlocks];
          newItems[ind].response_qcm_text_user = value;
          return newItems;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const updateFreeQuestion = async (apiType: any, value: any) => {
    try {
      const resp = await apiServiceNative.put(`/api${apiType}`, { response: value });
    } catch (e) {
      console.error(e);
    }
  };

  const scrollToSection = (ind: any) => {
    const element = document.getElementById(`title-${ind}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <LayoutResultat
      typeScroll="static"
      isWhite={true}
      showLogo={false}
      hideHeader={isDisconnected}
      index={index}
      isNew3={true}
      toBack={isDisconnected ? undefined : '/mes-ressources'}>
      {isDisconnected && <ShareFixedHeader />}
      {loading ? (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            color: 'white',
          }}>
          <p />
          Chargement en cours...
        </div>
      ) : (
        <>
          {showSignup && (
            <InlineSignup
              testImage={url}
              ebookResultId={id}
              ebookIndex={index || '0'}
              authorizedEbookId={catalogEbookId}
              contentType="ebook"
            />
          )}
          <div
            className={classes.containerEbookParent}
            style={showSignup ? { display: 'none' } : undefined}>
            <div className={classes.containerEbook}>
              <img src={url} alt="cover" className={classes.coverEbook} />
              <div style={{ marginTop: 70 }}>
                {allBloks.map((block: any, ind: number) => (
                  <div
                    key={block?.uniqueIdContent || block?.id || `block-${ind}`}
                    style={
                      block?.bloc_template !== 2
                        ? { padding: '20px 0px' }
                        : block?.title_type === 'subtitle'
                        ? { padding: '10px 0px' }
                        : { padding: '20px 0px 15px' }
                    }>
                    {renderTypeBlock(block, ind)}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </LayoutResultat>
  );
};

export default ViewEbook;
